import React, { useState } from 'react';
import {
	Grid,
	Typography,
	Button,
	InputBase,
	ButtonBase,
	Box,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import Logo from '../assets/images/Logo.png';
import { helperText } from '../assets/theme/Theme';
import { resetUserPassword } from '../services/UserService';

function ResetPassword(props) {
	const params = useParams();
	const navigate = useNavigate();
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [passwordError, setPasswordError] = useState({
		status: false,
		msg: '',
	});
	const [confirmPasswordError, setConfirmPasswordError] = useState({
		status: false,
		msg: '',
	});
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	function onChangePassword(e) {
		setPasswordError({ status: false, msg: '' });
		setPassword(e.target.value);
	}

	function onChangeConfirmPassword(e) {
		setConfirmPasswordError({ status: false, msg: '' });
		setConfirmPassword(e.target.value);
	}

	async function onResetPassword() {
		let err = false;

		if (password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			err = true;
		}

		if (confirmPassword === '') {
			setConfirmPasswordError({
				status: true,
				msg: 'Confirm password is Required.',
			});
			err = true;
		}

		if (password !== '' && password.length < 8) {
			setPasswordError({
				status: true,
				msg: 'Password should be at least 8 characters long.',
			});
			err = true;
		}

		if (password.length >= 8 && password !== confirmPassword) {
			setConfirmPasswordError({
				status: true,
				msg: "Passwords don't match.",
			});
			err = true;
		}

		if (err) {
			return;
		}

		const data = {
			userId: params.userId,
			key: params.keyId,
			password: password,
			confirmPassword: confirmPassword,
		};

		const result = await resetUserPassword(data);
		if (result.message === 'Success') {
			localStorage.clear();
			navigate('/');
			toast.success('Password reset successfully.');
		} else {
			toast.error(result.message);
		}
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}>
			<Grid container justifyContent={'center'}>
				<Grid item xs={10} md={4}>
					<Grid
						container
						flexDirection={'row'}
						justifyContent={'center'}
						alignItems={'center'}>
						<Box
							component={'img'}
							src={Logo}
							sx={{
								padding: '2px',
								borderRadius: '5px',
							}}
							width={180}
							height={45}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						md={12}
						style={{
							textAlign: 'left',
							border: '1px solid #F4F5F6',
							boxShadow:
								'0px 10px 110px 1px rgba(59, 59, 59, 0.08)',
							marginTop: '20px',
							paddingTop: '20px',
							padding: '15px',
							borderRadius: '10px',
							backgroundColor: '#FFF',
						}}>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingBottom="10px">
							Password
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								passwordError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={
									showPassword === false ? 'password' : 'text'
								}
								sx={{
									padding: '4px',
									width: '90%',
									color: '#777E90',
								}}
								error={passwordError.status}
								onChange={onChangePassword}
							/>
							<ButtonBase
								onClick={() => setShowPassword(!showPassword)}>
								{showPassword ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid>
						<Typography style={helperText}>
							{passwordError.msg}
						</Typography>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingY="10px">
							Confirm Password
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								confirmPasswordError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={
									showConfirmPassword === false
										? 'password'
										: 'text'
								}
								sx={{
									padding: '4px',
									width: '90%',
									color: '#777E90',
								}}
								error={confirmPasswordError.status}
								onChange={onChangeConfirmPassword}
							/>
							<ButtonBase
								onClick={() =>
									setShowConfirmPassword(!showConfirmPassword)
								}>
								{showConfirmPassword ? (
									<HideEyeIcon
										error={confirmPasswordError.status}
									/>
								) : (
									<EyeIcon
										error={confirmPasswordError.status}
									/>
								)}
							</ButtonBase>
						</Grid>
						<Typography style={helperText}>
							{confirmPasswordError.msg}
						</Typography>
						<Grid container justifyContent={'center'}>
							<Button
								onClick={onResetPassword}
								style={{
									width: '100%',
									boxShadow: 'none',
									marginTop: '10px',
									textTransform: 'none',
									backgroundColor: '#28696D',
								}}
								variant="contained">
								Reset
							</Button>
							<Typography
								variant="subtitle2"
								style={{
									color: '#777E91',
									paddingTop: '10px',
									paddingBottom: '10px',
								}}>
								<a href="/" style={{ textDecoration: 'none' }}>
									<span
										style={{
											color: '#777E90',
											cursor: 'pointer',
										}}>
										Back to Login
									</span>
								</a>
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
}

export default ResetPassword;
